import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { getUserManager, authenticateUser } from '@axa-fr/react-oidc-core';

// window.location is already this dead-end URL when this renders, so the default sign-in flow
// (which returns here) would loop forever - the return target is pinned to home instead.
// isForce=true so an unrelated valid session never turns the retry into a no-op.
export const NotAuthenticated = () => {
  const navigate = useNavigate();

  const signInAgain = () => {
    const userManager = getUserManager();
    // authenticateUser only ever calls history.push(...), never .replace/.length/etc, so a
    // plain object exposing push is enough - it never needs a real v5 history instance.
    authenticateUser(userManager, window.location, { push: navigate })(true, '/');
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center gap-4 bg-white">
      <h1 className="text-2xl font-bold">Not Authenticated.</h1>
      <button
        type="button"
        onClick={signInAgain}
        className="inline-flex items-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
      >
        Sign in again
      </button>
    </div>
  );
};

export default NotAuthenticated;
